import Toggle from 'components/ReusableComponents/Toggle'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'

import { selectCurrentBalance, selectIsInternalAdmin } from '../../../../accessors/index'
import ElectronicCheck from '../../../../components/ReusableComponents/ElectronicCheck/index'
import useForm from '../../../../hooks/useForm'
import { urlTypes } from '../paymentHelpers'
import styles from './MakeCheckPayment.module.scss'

const MakeCheckPayment = ({
  handleSubmit,
  savedPaymentMethods,
  selectedSavedPaymentMethodId,
  goBackPath,
  isAmountLocked,
  isInitialPaymentMade
}) => {
  const { type: paymentType } = useParams()

  const isInternalAdmin = useSelector(selectIsInternalAdmin)

  const amount = Math.max(useSelector(selectCurrentBalance), 0)

  const formObject = useForm({
    PaymentClearedOn: '',
    bankRoutingNumber: '',
    accountNumber: '',
    checkNumber: '',
    institutionNumber: '',
    branchNumber: '',
    holder: '',
    bankName: '',
    amount: paymentType === urlTypes.payment ? amount : 0,
    usedSavedCheck: null,
    country: 'US',
    isForManualProcessing: isInitialPaymentMade ? false : true
  })

  // eslint-disable-next-line no-unused-vars
  const [formData, _h, setFormData] = formObject

  const [isFormValid, setIsFormValid] = useState(false)

  useEffect(() => {
    const {
      bankRoutingNumber,
      accountNumber,
      checkNumber,
      bankName,
      branchNumber,
      institutionNumber,
      usedSavedCheck,
      amount,
      country,
      holder
    } = formObject[0]

    if (usedSavedCheck && bankName && holder) {
      setIsFormValid(checkNumber.length > 2 && amount > 0)
      return
    }

    if (country === 'US') {
      if (
        bankRoutingNumber.length === 9 &&
        accountNumber.length > 5 &&
        checkNumber.length > 2 &&
        (paymentType === urlTypes.payment ? Number(amount) > 0 : true) &&
        bankName &&
        holder.length > 2
      ) {
        setIsFormValid(true)
      } else {
        setIsFormValid(false)
      }
    }

    if (country === 'CA') {
      if (
        branchNumber.length === 5 &&
        institutionNumber.length === 3 &&
        accountNumber.length > 5 &&
        checkNumber.length > 2 &&
        (paymentType === urlTypes.payment ? Number(amount) > 0 : true) &&
        bankName &&
        holder.length > 2
      ) {
        setIsFormValid(true)
      } else {
        setIsFormValid(false)
      }
    }
  }, [formData, formObject, paymentType])

  useEffect(() => {
    if (selectedSavedPaymentMethodId) {
      const selectedMethod = savedPaymentMethods.find(
        method => method.paymentAccountId === selectedSavedPaymentMethodId
      )

      if (selectedMethod?.method === 'Check' || selectedMethod?.method === 'ACH') {
        setFormData({
          usedSavedCheck: selectedMethod,
          holder: selectedMethod.accountHolderName,
          bankName: selectedMethod.friendlyDisplayName.match(/(.+)-\d+$/)
            ? selectedMethod.friendlyDisplayName.match(/(.+)-\d+$/)[1]
            : ''
        })
      }
    }
  }, [
    selectedSavedPaymentMethodId,
    savedPaymentMethods,
    setFormData,
    isInitialPaymentMade
  ])

  const { usedSavedCheck, PaymentClearedOn, amount: PaymentAmount, ...check } = formData

  return (
    <div className={styles.wrapper}>
      <div className={styles.eCheckForm}>
        <div className={styles.content}>
          {isInternalAdmin && (
            <Toggle
              className={styles.manualProcessingToggle}
              label="Check already cached at bank"
              checked={formData.isForManualProcessing}
              handleChange={e => {
                setFormData({ isForManualProcessing: e.target.checked })
              }}
              disabled={!isInitialPaymentMade}
            />
          )}
          <ElectronicCheck
            formObject={formObject}
            isVoid={paymentType === urlTypes.addMethod}
            isAmountLocked={isAmountLocked}
          />
          <div className={styles.legalText}>
            By supplying this information and completing the transaction, I hereby
            authorize Directful Inc. to initiate a debit against the above Bank Account,
            and to charge the same to such Bank Account. I acknowledge that the
            origination of ACH transactions to my Account must comply with the provisions
            of U.S. law.
          </div>
        </div>
        <div className={styles.controls}>
          <Link className={styles.secondaryButton} to={goBackPath}>
            Cancel
          </Link>
          <button
            onClick={() =>
              handleSubmit({
                check: {
                  ...check,
                  bankRoutingNumber:
                    check.country === 'CA'
                      ? check.branchNumber + check.institutionNumber
                      : check.bankRoutingNumber
                },
                PaymentAmount,
                PaymentMethod: formData.isForManualProcessing
                  ? 'Check'
                  : check.country === 'CA'
                  ? 'Check'
                  : 'ACH',
                PaymentClearedOn,
                SubsidiaryBillingSavedPaymentAccountId: usedSavedCheck
                  ? usedSavedCheck.paymentAccountId
                  : null
              })
            }
            className={styles.primaryButton}
            disabled={!isFormValid}
          >
            {paymentType === urlTypes.payment
              ? 'Save & confirm payment'
              : 'Confirm details'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default MakeCheckPayment
